export default __webpack_public_path__ + "assets/images/953a004921dcc8792b3a68a90af37d01.png";